import script from "./ProfilePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilePanel.vue?vue&type=script&setup=true&lang=js"

import "./ProfilePanel.vue?vue&type=style&index=0&id=40626f6b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40626f6b"]])

export default __exports__